import React, { useState } from "react";
import bottomCaret from "buba-components/src/assets/icons/other/bottomCaret.svg";
import cx from "classnames";

import Button from "../Button";
import Text from "../Text";

import styles from "./Accordion.scss";

interface AccordionElementProps {
  title: string;
  children: React.ReactNode;
  isExpanded?: boolean;
  onToggle?: () => void;
  customStyles?: string;
}

interface AccordionProps {
  title?: string;
  children: React.ReactNode;
  customStyles?: string;
}

export const AccordionElement = ({
  title,
  children,
  isExpanded = false,
  onToggle,
  customStyles
}: AccordionElementProps) => {
  const [internalExpanded, setInternalExpanded] = useState(false);

  const expanded = onToggle !== undefined ? isExpanded : internalExpanded;
  const handleToggle = onToggle || (() => setInternalExpanded(!internalExpanded));

  return (
    <div
      className={cx(styles.accordionElement, customStyles, {
        [styles.expanded]: expanded
      })}
      data-testid="accordion-element"
    >
      <Button
        variant="clean"
        customStyles={styles.accordionHeader}
        onClick={handleToggle}
        iconLeft={bottomCaret}
        data-testid="accordion-header"
        aria-expanded={expanded}
      >
        <Text additionalClasses={styles.accordionTitle} variant="caption">
          {title}
        </Text>
      </Button>
      <div
        className={cx(styles.accordionContent, {
          [styles.accordionContentExpanded]: expanded
        })}
        data-testid="accordion-content"
      >
        <div className={styles.accordionContentInner}>
          <div className={styles.accordionContentBody}>{children}</div>
        </div>
      </div>
    </div>
  );
};

const Accordion = ({ title, children, customStyles }: AccordionProps) => {
  return (
    <div className={cx(styles.accordion, customStyles)} data-testid="accordion">
      {title && (
        <h3 className={styles.accordionMainTitle} data-testid="accordion-title">
          {title}
        </h3>
      )}
      <div className={styles.accordionElements}>{children}</div>
    </div>
  );
};

export default Accordion;
